module.exports = __webpack_public_path__ + "static/media/bussiness_policy_img5.078cf83a.png";